module.exports = __webpack_public_path__ + "static/media/decoded.e1ee2c2f.jpg";